module.exports = __webpack_public_path__ + "OpenSans-SemiBold.1113ce5ba90c2a7fd2d1.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-SemiBold.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-SemiBold.ttf
// module chunks = styles